
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/alertsContainer',['Vue', 'vue!../reusableComponents/alerts'],function(Vue, alertsComponent){
        return {
            name:'alertsContainer',
            template:template,
            components: {
                'alerts-component': alertsComponent
            },
            computed: {
                alerts: function() {
                    return this.$store.getters['alerts/alerts'];
                }
            }
        }
    })
})('<alerts-component :alerts="alerts" />');
